<template>
<div class="bodyContent-form">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="container-fluid  ">
                    
                    <div class="container ">
                        <div class="container form-container">
                            <div class="row">
                                <div class="col-lg-1 col-md-1 col-sm-12"></div>
                                <div class="col-lg-10 col-md-10 col-sm-12">
                                    <div class="fourZeroFour">
                                        <div class="container">
                                            <!-- <div class="text-center">
                                                <img src="images/404.png" class="rounded" alt="404">
                                            </div> -->
                                            <h2>There was an error with your request</h2>
                                            <p>We are always working on building you a better site, and that page might be in a new location or is being improved. Try using our search bar or the links provided below to find what you are looking for.</p>

                                            <h4>Possible reasons for this error:</h4>
                                            <ul>
                                                <li> We moved the location of the page on our servers</li>
                                                <li>The bookmark you used is outdated</li>
                                                <li>The URL was entered incorrectly</li>
                                            </ul>
                                            <h4>Need help?</h4>
                                            <ul>
                                                <li>Email us - <a href="mailto:support@wevisu.com">support@wevisu.com</a></li>
                                                
                                            </ul>
                                            <router-link class="btn btn-primary" to="/"> Back to Home
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-1 col-md-1 col-sm-12"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
 
<script>
 

export default {
  components: {
    
  },
  mounted() {}
};
</script>
